import type { QualityChanges } from '@/lib/types'

export function QualityEditWarning({ changes }: { changes?: QualityChanges | null }) {
  if (!changes || (!changes.rebuild_required && !changes.peer_review_stale)) return null
  return <section className="note warn" role="status">
    {changes.rebuild_required && <p><strong>Careful: the current task package needs to be rebuilt.</strong></p>}
    {changes.peer_review_stale && <p><strong>Careful: this new task brief has received no stage 3 peer review.</strong></p>}
  </section>
}
